import type { IReportParams } from '../utils';

import { getParamsByCampaign, getParamsByTime, getReportMetricKey } from '../utils';
import { usePageAnalyticDetailsStore } from '~/modules/page-analytic';
import { useHandleNavigate } from '~/hooks/useHandleNavigate';
import { useMetricsTimeFilter } from '~/modules/analytics';
import { useReportPageTitleStore } from '../stores';
import { INavigateKey } from '~/types/navigate';
import { ROUTE_PATH } from '~/config/navigate';
import { EReportParamKeys } from '../types';

export function useNavigateToReport() {
  const { handleNavigate } = useHandleNavigate();
  const { currentDates, dateTimePicked } = useMetricsTimeFilter();

  const pageTitleFromPageDetails = usePageAnalyticDetailsStore((state) => state.pageTitle);
  const setPageTitle = useReportPageTitleStore((state) => state.setPageTitle);

  function getParams(params?: IReportParams) {
    return {
      ...(params?.locationPath && { [EReportParamKeys.PATH]: params.locationPath }),
      ...getParamsByCampaign(params),
      ...getParamsByTime(currentDates, dateTimePicked),
      ...(params?.mode && { [EReportParamKeys.MODE]: params.mode }),
      ...(params?.from && { [EReportParamKeys.FROM]: params.from }),
    };
  }

  const updatePageTitle = (locationPath?: string) => {
    if (!pageTitleFromPageDetails || !locationPath) return;

    //Case: Update filter in page detail, but page not found
    setPageTitle(pageTitleFromPageDetails);
  };

  function handleNavigateToReport(metricKey: string, params?: IReportParams) {
    const reportMetricKey = getReportMetricKey(metricKey, params?.reportCampaign?.id);

    updatePageTitle(params?.locationPath ?? undefined);
    handleNavigate(`${ROUTE_PATH[INavigateKey.Reports]}/${reportMetricKey}`, {
      params: getParams(params),
    });
  }

  return {
    handleNavigateToReport,
  };
}
